module.exports = __webpack_public_path__ + "static/media/643bc00e-aac6-4339-9e41-f80a80150d9a.83639daf.jpeg";